document.addEventListener('DOMContentLoaded', function () {
  let accordionTitles = document.querySelectorAll('.faq-title');

  if (accordionTitles) {
    accordionTitles.forEach((title) => {
      title.addEventListener('click', function () {
        let parent = title.parentElement;
        let content = parent.querySelector('.faq-content');
        let plusIcon = parent.querySelector('.pluse_icons');
        let minusIcon = parent.querySelector('.minus_icon');

        let isOpen = parent.classList.contains('active-accordion');

        document.querySelectorAll('.faq-item').forEach((item) => {
          let itemContent = item.querySelector('.faq-content');
          let itemPlusIcon = item.querySelector('.pluse_icons');
          let itemMinusIcon = item.querySelector('.minus_icon');

          item.classList.remove('active-accordion');
          itemContent.classList.remove('margin-top-9');
          itemContent.style.height = itemContent.scrollHeight + 'px';
          requestAnimationFrame(() => {
            itemContent.style.height = '0px';
          });
          itemPlusIcon.style.display = 'block';
          itemMinusIcon.style.display = 'none';
        });

        if (!isOpen) {
          parent.classList.add('active-accordion');
          content.classList.add('margin-top-9');
          content.style.height = '0px';
          requestAnimationFrame(() => {
            content.style.height = content.scrollHeight + 'px';
          });
          plusIcon.style.display = 'none';
          minusIcon.style.display = 'block';
        }
      });
    });
  }

  let allContents = document.querySelectorAll('.faq-content');
  if (allContents) {
    allContents.forEach((el) => {
      el.addEventListener('transitionend', function () {
        if (el.parentElement.classList.contains('active-accordion')) {
          el.style.height = 'auto';
        }
      });
    });
  }
});
